import React from 'react';
import ReactDOM from 'react-dom';
import { addCtnCommonAttribute } from "./SgiCtnComm"
import { convertModuleByGuid } from "./SgiCompComm"
import { sgiFormCtlBaseFun } from "./sgiFormCtlBaseFun"
import { uuid, copy, copyArr } from 'rt-sd-common/sgiCommon/sgiCommon'
import { Menu, Icon, Form, Button } from 'antd';
const SubMenu = Menu.SubMenu;
const MenuItemGroup = Menu.ItemGroup;
import { bindValue, bindEvent, setFormCtlLayout, AddFormCtlCommonAttribute } from './sgiFormCtlComm'
import { StandardCode } from 'rt-sd-common/sgiFactory/StandardCode';
import { SgiEventHandler } from './SgiEventHandler';
import { getConstByKey } from './sgiBaseComp/SgiCommon';



// let data = [
//     {
//         mode:'sub',
//         menuId: 1,
//         name: '员工管理',
//         children: [
//             {
//                 mode:'item',
//                 menuId: 3,
//                 name: '添加员工',
//                 children: []
//             },
//             {
//                 mode:'sub',
//                 menuId: 4,
//                 name: '删除员工',
//                 children: [
//                     {
//                         mode:'item',
//                         menuId: 6,
//                         name: '按姓名删除',
//                         children: []
//                     },
//                     {
//                         mode:'sub',
//                         menuId: 7,
//                         name: '按工号删除',
//                         children: [
//
//                             {
//                                 mode:'item',
//                                 menuId: 8,
//                                 name: '按工号删除1',
//                                 children: []}
//                         ]
//                     }
//                 ]
//             }
//         ],
//     },
//     {
//         mode:'sub',
//         menuId: 2,
//         name: '工资管理',
//         children: [
//             {
//                 mode:'item',
//                 menuId: 5,
//                 name: '修改工资',
//                 children: []
//             }
//         ],
//     },
//     {
//         mode:'item',
//         menuId: 9,
//         name: '财务管理',
//         children: [
//         ],
//     },
// ];


class SgiMenu extends React.Component {

    static defaultProps = {
    };  // 注意这里有分号
    static propTypes = {
    };  // 注意这里有分号

    constructor(props) {
        super(props);
        //初始化state属性
        this.initState();
        this.state.displayField = '';
        this.state.saveField = '';
        this.state.childrenName = 'cldSet';
        this.state.menuData = [];
    }

    /**
     * 根据描述创建文本框
     * @param {父组件} parentModule
     * @param {组件描述} moduleDesc
     * @param {绑定实例ID} bdInst
     * @param {当前工作区} ws
     * @param {make类型} type
     */
    menu_mk(parentModule, moduleDesc, bdInst, objFct, type) {

        //获取需要展示的数据信息
        var moduleDesc = this.props.moduleDesc;
        if (!moduleDesc) {
            return;
        }
        //绑定数据，创建表格store 搜索条、翻页控件需要使用该信息，所以先创建
        var menuStore = this.getMenuData(moduleDesc, objFct);
        this.state.menuData = menuStore;
        //转换基础属性
        this.AddInputAttribute(moduleDesc, this.state.formItemProps, this.state.inputprops);
        //转换form公共属性
        // AddFormCtlCommonAttribute(this, moduleDesc, this.state.formItemProps,this.state.inputprops );
        //设置布局
        // setFormCtlLayout(moduleDesc, this.state.formItemProps, this.state.inputprops);
        //绑定事件
        this.bindEvent(moduleDesc, this.state.inputprops, this.state.functions);
        //绑定值
        // bindValue(this, moduleDesc, bdInst, objFct,this.state.formItemProps, this.state.inputprops);

    }

    bindEvent(moduleDesc, inputprops, functions, type) {
        //拖拽模式 不生成事件
        if (type == 'dnd') {
            return;
        }
        var iCLsn = moduleDesc.iCLsn; // 用户自定义点击事件
        if (iCLsn) {
            var $iCLsn = new Function("module", "objFct", "itemData", "item", iCLsn);
            functions.onClick = $iCLsn;
            inputprops.onClick = SgiEventHandler.menuClick.bind(this);
        }
    }

    /**
    * 组装下拉框内容
    * @param {描述} moduleDesc
    */
    getMenuData(moduleDesc, objFct) {

        // this.state.store = []
        //参数工厂获取标准代码 暂时当获取到了 属性为'sc', 'te', 'c'
        //下面是临时数据
        var scId = moduleDesc.rSC; //绑定实例名
        var tData;
        if (scId) {
            // 下拉窗列表值在标准代码中的id
            tData = StandardCode.getSC(scId);
            this.state.displayField = 'te';
            this.state.saveField = 'c';
        } else {
            var insName = getConstByKey(this, moduleDesc.insName); //绑定实例名

            //取得绑定类名`  var tData = [];
            if (insName && objFct) {
                tData = objFct.get(insName);
            }
            this.state.displayField = moduleDesc.showKey;
            this.state.saveField = moduleDesc.saveKey;
        }
        if (!tData) {
            return [];
        }
        return tData;

    }

    /**
     * 属性转换
     * @param {描述信息} moduleDesc
     * @param {属性} formItem
     * @param {属性} inputprops
     */
    AddInputAttribute(moduleDesc, formItemProps, inputprops) {
        //菜单位置
        var mode = moduleDesc.mode;
        if (mode && (mode == "horizontal")) {//水平
            inputprops.mode = "horizontal";
        } else if (mode && (mode == "inline")) {//垂直菜单
            inputprops.mode = "inline";
            // inputprops.inlineCollapsed = false;
            // inputprops.style= {width:235};
        } else if (mode && (mode == "vertical")) {//垂直弹出
            inputprops.mode = "vertical";
        } else if (mode && (mode == "vertical-right")) {//垂直向下弹出
            inputprops.mode = "vertical-right";
        }

        // 主题颜色
        var theme = moduleDesc.theme;
        if (theme) inputprops.theme = theme;

        // inline 时菜单是否收起状态
        // var inlineCollapsed = moduleDesc.inlineCollapsed;
        // if (inlineCollapsed) inputprops.inlineCollapsed = inlineCollapsed;

        // 宽，高
        var width = moduleDesc.ctlW;
        if (width) inputprops.style.width = width;
        var height = moduleDesc.ctlH;
        if (height) inputprops.style.height = height;

    }

    /**
    * 递归生成菜单
    * @param menuObj
    * @returns {Array}
    */
    // generateMenu(menuObj) {
    //     var items;
    //     var vdom = [];
    //     var  childSize = menuObj.length;
    //     for (var i = 0; i < childSize; i++) {
    //         var wvJson = menuObj[i];
    //         if(wvJson.mode == "sub"){
    //             items = this.generateMenu1(wvJson.children);
    //             vdom.push(<SubMenu title={<span><Icon type="setting" />{wvJson.name}</span>}>
    //             {items}
    //             </SubMenu>);
    //
    //         }else if(wvJson.mode == "item"){
    //             vdom.push(<Menu.Item key ={wvJson.key}>{wvJson.name}</Menu.Item>);
    //         }
    //     }
    //     return vdom;
    //
    // }
    // generateMenu1(menuObj) {
    //     var items;
    //     var vdom = [];
    //     var  childSize = menuObj.length;
    //     for (var i = 0; i < childSize; i++) {
    //         var wvJson = menuObj[i];
    //         if(wvJson.mode == "sub"){
    //             items = this.generateMenu1(wvJson.children);
    //             vdom.push(<SubMenu title={<span><Icon type="setting" />{wvJson.name}</span>}>
    //             {items}
    //             </SubMenu>);
    //
    //         }else if(wvJson.mode == "item"){
    //             vdom.push(<Menu.Item key ={wvJson.key}>{wvJson.name}</Menu.Item>);
    //         }
    //     }
    //
    //     return vdom;
    //
    // }
    // fitTreeNodes1(comboBoxData) {
    //     var items;
    //     let scList = [];
    //     let childrenName = this.state.childrenName;
    //     var size = comboBoxData.length;
    //     for (let i = 0; i < size; i++) {
    //         var item = comboBoxData[i];
    //         if(item[childrenName]&& item[childrenName].length){
    //             items = this.fitTreeNodes2(item[childrenName]);
    //             scList.push(<SubMenu title={item[this.state.displayField]} key={item[this.state.saveField]} children={items}/>);
    //         }
    //          scList.push(<Menu.Item key ={item[this.state.saveField]}>{item[this.state.displayField]}</Menu.Item>);
    //     }
    //     return scList;
    // };
    //
    // fitTreeNodes2(comboBoxData) {
    //     var items;
    //     let scList = [];
    //     let childrenName = this.state.childrenName;
    //     var size = comboBoxData.length;
    //     for (let i = 0; i < size; i++) {
    //         var item = comboBoxData[i];
    //         if(item[childrenName]&& item[childrenName].length){
    //             items = this.fitTreeNodes2(item[childrenName]);
    //              scList.push(<SubMenu title={item[this.state.displayField]} key={item[this.state.saveField]} children={items}/>);
    //         }
    //          scList.push(<Menu.Item key ={item[this.state.saveField]}>{item[this.state.displayField]}</Menu.Item>);
    //     }
    //     return scList;
    // };

    // 生成菜单子项，不写key不报错
    fitMenuItems = (data) => data.map((item) => {
        let childrenName = this.state.childrenName;

        const icon = item["_icon"] || "appstore";
        let title = (
            <span>
                <Icon type={icon} />
                <span>{item[this.state.displayField]}</span>
            </span>)

        if (item[childrenName] && item[childrenName].length) {
            return <SubMenu itemData={item} title={title} key={uuid(8)} children={this.fitMenuItems(item[childrenName])} />;
        }
        return <Menu.Item itemData={item} key={uuid(8)}>{title}</Menu.Item>;
    });

    refresh = () => {
        this.loaded = false;
        this.setState({ loading: false });
    }


    //渲染并返回一个虚拟DOM
    render = function () {

        if (!this.loaded) {
            var { parentModule, moduleDesc, bdInst, objFct, type } = this.props;
            //组装属性 初始化属性到this.state
            this.menu_mk(parentModule, moduleDesc, bdInst, objFct, type);
            this.loaded = true;
        }

        return (
            <Menu {...this.state.inputprops} >
                {this.fitMenuItems(this.state.menuData)}
            </Menu>
        )

    };
}
//给类添加公共方法
Object.assign(SgiMenu.prototype, sgiFormCtlBaseFun);
export { SgiMenu };
export default SgiMenu;


// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiMenu.js